import { render, staticRenderFns } from "./ConvenientSearchPj.vue?vue&type=template&id=6dcb962a&scoped=true"
import script from "./ConvenientSearchPj.vue?vue&type=script&lang=js"
export * from "./ConvenientSearchPj.vue?vue&type=script&lang=js"
import style0 from "./ConvenientSearchPj.vue?vue&type=style&index=0&id=6dcb962a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcb962a",
  null
  
)

export default component.exports